import { PropsWithChildren } from "react";
import LoadingIcon from "./LoadingIcon";

interface IGenericDataTableProps<T> {
    data: T[];
    dataFormatter: (data: T[]) => JSX.Element;
    noDataMessage: string;
    columnCount: number;
    isLoading: boolean;
};

export default function GenericDataTable<T>(props: PropsWithChildren<IGenericDataTableProps<T>>)
{
    const getTableRows = () => {
        if (props.data.length === 0) 
            return (
                <tr>
                    <td colSpan={props.columnCount}>
                        <div className='d-flex justify-content-center mt-3 mb-3'>
                            {props.noDataMessage}
                        </div>
                    </td>
                </tr>
            );
        else
            return props.dataFormatter(props.data);
    };

    if (props.isLoading){
        return <div className="mt-5 text-center">
            <LoadingIcon />
        </div>;
    }
    
    return (
        <table className='table table-striped'>
            <thead>
                {props.children}
            </thead>
            <tbody>
                {getTableRows()}
            </tbody>
        </table>
    );
}